import { css } from 'lit';

// Dark-variant token overrides. Declarations only (no selector) — applied by
// variables.css.mjs under both [data-theme-mode="dark"] and
// @media (prefers-color-scheme: dark). Components consume the semantic surface
// layer + the palette, so overriding here themes the whole DS.
//
// Contrast targets (WCAG): body text ≥4.5:1, large/bold text & UI (borders,
// icons, outlines) ≥3:1 against the surface they sit on (raised #1b2127 / base
// #0f1419). Brand blues are LIGHTENED here so outline/accent uses stay visible
// on dark — the dark navies blend into the background otherwise.
export default css`
  /* Surfaces */
  --surface-base: #0f1419;        /* page */
  --surface-raised: #1b2127;      /* elevated panels */
  --surface-sunken: #14191e;
  --surface-hover: #232c35;
  --surface-overlay: rgba(0, 0, 0, 0.65);
  --surface-knob: #e7eaee;

  /* Borders — visible, ≥3:1 for prominent (input/control) borders */
  --border-subtle: #3a4651;       /* dividers / subtle outlines */
  --border-strong: #62707e;       /* input + control outlines */

  /* Text */
  --on-surface: #f3f5f7;          /* primary (~16:1) */
  --on-surface-muted: #b8c0c9;    /* secondary (~7:1) */
  --on-surface-subtle: #9099a3;   /* tertiary (~4.6:1) */
  --base-text-color: #f3f5f7;

  /* Gray ramp inverted: light ends (surfaces) → dark; dark ends (text) → light;
     mids raised so gray-3 borders/icons and gray-4/5 text clear the 3:1 / 4.5:1 bars. */
  --color-gray-1: #161b21;        /* lightest surface → darkest */
  --color-gray-2: #1f262d;
  --color-gray-3: #6b7682;        /* borders / icons / dim text — visible (>=3:1 on base) */
  --color-gray-4: #99a2ab;        /* tertiary text/icons */
  --color-gray-5: #aab2bb;
  --color-gray-6: #b8c0c9;        /* muted text */
  --color-gray-7: #cfd5db;
  --color-gray-8: #e3e7ea;
  --color-gray-9: #f3f5f7;        /* darkest text → lightest */
  --color-dark-gray: #f3f5f7;     /* legacy text aliases → light */
  --color-dark-gray-1: #f3f5f7;
  --color-dark-gray-2: #f3f5f7;

  /* Brand blues — lightened for dark. Filled controls keep white labels
     (large/bold ≥3:1); outline/clear/menu text & borders become legible. */
  --color-primary: #4d80e0;
  --color-primary-light: #6f9bf0;
  --color-primary-light-1: #6f9bf0;   /* alert outline "default" border */
  --color-primary-dark: #4a78dc;      /* outline/menu/clear TEXT + press fill */
  --color-secondary: #2f93da;          /* white-on-fill >=3:1 AND outline >=3:1 */
  --color-secondary-light: #4aa6ec;
  --color-secondary-light-1: #4aa6ec;
  --color-secondary-dark: #2580c0;
  --color-hover: #6f9bf0;             /* hover accent / focus shadow */

  /* Literal --color-white/--color-black are intentionally NOT overridden
     (white text on a filled/brand background stays white). */
`;
